import React, { createContext, useContext, useState } from "react";

export const WarehouseContext = createContext();
export const useWarehouse = () => useContext(WarehouseContext);

export const WarehouseProvider = ({ children }) => {
  const [warehouses, setWarehouses] = useState([
    {
      id: 1,
      name: "Ana Depo",
      location: "İstanbul",
      status: "Aktif",
      createdAt: new Date(),
      updatedAt: new Date(),
      shelves: [
        {
          id: 1,
          name: "Raf 1",
          status: "Aktif",
          personelId: 2,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: 2,
          name: "Raf 2",
          status: "Aktif",
          personelId: 1,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
      ],
    },
  ]);

  // ----------------- Depo işlemleri -----------------
  const addWarehouse = ({ name, location, status, personnel }) => {
    if (warehouses.some(w => w.name === name)) {
      alert("Depo adı benzersiz olmalı!");
      return;
    }
    
    const newId = warehouses.length > 0 ? Math.max(...warehouses.map(w => w.id)) + 1 : 1;

    setWarehouses(prev => [
      ...prev,
      {
        id: newId,
        name,
        location,
        status,
        personnel,
        createdAt: new Date(),
        updatedAt: new Date(),
        shelves: [],
      },
    ]);
  };

  const updateWarehouse = (id, updates) => {
    setWarehouses(prev =>
      prev.map(w =>
        w.id === id
          ? { ...w, ...updates, updatedAt: new Date() }
          : w
      )
    );
  };

  const deleteWarehouse = (id) => {
    setWarehouses(prev => prev.filter(w => w.id !== id));
  };

  // ----------------- Raf işlemleri -----------------
  const addShelf = (warehouseId, { name, status, personelId }) => {
    setWarehouses(prev =>
      prev.map(w => {
        if (w.id === warehouseId) {
          if (w.shelves.some(s => s.name === name)) {
            alert("Bu depoda raf adı benzersiz olmalı!");
            return w;
          }
          
          const newShelfId = w.shelves.length > 0 ? Math.max(...w.shelves.map(s => s.id)) + 1 : 1;
          return {
            ...w,
            shelves: [
              ...w.shelves,
              { id: newShelfId, name, status, personelId, createdAt: new Date(), updatedAt: new Date() },
            ],
          };
        }
        return w;
      })
    );
  };

  const updateShelf = (warehouseId, shelfId, updates) => {
    setWarehouses(prev =>
      prev.map(w => {
        if (w.id === warehouseId) {
          return {
            ...w,
            shelves: w.shelves.map(s =>
              s.id === shelfId
                ? { ...s, ...updates, updatedAt: new Date() }
                : s
            ),
          };
        }
        return w;
      })
    );
  };

  const deleteShelf = (warehouseId, shelfId) => {
    setWarehouses(prev =>
      prev.map(w =>
        w.id === warehouseId
          ? { ...w, shelves: w.shelves.filter(s => s.id !== shelfId) }
          : w
      )
    );
  };

  return (
    <WarehouseContext.Provider
      value={{
        warehouses,
        addWarehouse,
        updateWarehouse,
        deleteWarehouse,
        addShelf,
        updateShelf,
        deleteShelf,
      }}
    >
      {children}
    </WarehouseContext.Provider>
  );
};
